import { render, staticRenderFns } from "./AdminDepartmentChatId.vue?vue&type=template&id=6efc4042&"
import script from "./AdminDepartmentChatId.vue?vue&type=script&lang=ts&"
export * from "./AdminDepartmentChatId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
